import { StudyActionRef } from 'helper/flux/myStudyRow';
import { useUploadDownloadLinkMutation } from 'services/api/studies';
import useStudyDownload from 'utils/hooks/flux/shared/useStudyDownload';

// Flux Upload: previvaz-arquivo/get-download-link
export default function useUploadDownload(study: StudyActionRef) {
  return useStudyDownload(study, useUploadDownloadLinkMutation);
}
